var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    {
      ref: "sidebar",
      staticClass: "has-background-dark has-text-light",
      class: { active: _vm.isActive },
      attrs: { id: "sidebar" }
    },
    [
      _vm.enabled
        ? _c(
            "button",
            {
              staticClass:
                "sidebar-toggle button is-dark has-background-black-bis",
              attrs: { type: "button" },
              on: { click: _vm.toggle }
            },
            [_c("b-icon", { attrs: { icon: _vm.icon, type: "" } })],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "nav",
        {
          staticClass: "navbar has-background-black-ter",
          attrs: { role: "navigation", "aria-label": "dropdown navigation" }
        },
        [
          _c("div", { staticClass: "navbar-brand title" }, [
            _c("h1", [_vm._v(_vm._s(_vm.$app.name))]),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.$app.version))])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "navbar-menu" }, [
            _c(
              "div",
              { staticClass: "navbar-end" },
              [
                _c(
                  "b-dropdown",
                  {
                    attrs: { position: "is-bottom-left", "aria-role": "menu" }
                  },
                  [
                    _c(
                      "a",
                      {
                        staticClass: "navbar-item",
                        attrs: { slot: "trigger", role: "button" },
                        slot: "trigger"
                      },
                      [
                        _c("span"),
                        _vm._v(" "),
                        _c("b-icon", {
                          attrs: { icon: "menu-down", type: "is-white" }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.$store.getters["status"] !== "public"
                      ? _c(
                          "b-dropdown-item",
                          { attrs: { custom: "", "aria-role": "menuitem" } },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$t("login.logged_as")) +
                                " "
                            ),
                            _c("b", [
                              _vm._v(_vm._s(_vm.$store.getters["user"]))
                            ])
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "b-dropdown-item",
                      { attrs: { "has-link": "", "aria-role": "menuitem" } },
                      [
                        _c(
                          "a",
                          {
                            attrs: {
                              href: "http://kappazeta.ee",
                              target: "_blank"
                            }
                          },
                          [_vm._v("\n              KappaZeta\n            ")]
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "b-dropdown-item",
                      {
                        attrs: { "aria-role": "menuitem" },
                        on: { click: _vm.openAbout }
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("about")) +
                            "\n          "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("hr", {
                      staticClass: "dropdown-divider",
                      attrs: { "aria-role": "menuitem" }
                    }),
                    _vm._v(" "),
                    _vm.$store.getters.isLoggedIn &&
                    _vm.$store.getters["status"] !== "public"
                      ? _c(
                          "b-dropdown-item",
                          {
                            attrs: { value: "logout", "aria-role": "menuitem" },
                            on: { click: _vm.logout }
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$t("login.logout")) +
                                "\n          "
                            )
                          ]
                        )
                      : _vm._e()
                  ],
                  1
                )
              ],
              1
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c("dataselector-component"),
      _vm._v(" "),
      _c("div", { staticClass: "scroller" }, [
        _c(
          "div",
          [
            _vm.isSearchAvailable ? _c("search-component") : _vm._e(),
            _vm._v(" "),
            _vm.isSearchResultsAvailable
              ? _c("search-results-component", {
                  attrs: { visible: !_vm.isSearchResultSelected }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.isSearchResultSelected
              ? _c("search-result-info-component")
              : _vm._e(),
            _vm._v(" "),
            !_vm.isSearchResultsAvailable && !_vm.isSearchResultSelected
              ? _c("map-filter-component")
              : _vm._e(),
            _vm._v(" "),
            !_vm.isSearchResultsAvailable && !_vm.isSearchResultSelected
              ? _c("help-component")
              : _vm._e()
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }